import React, { useEffect } from 'react';
import { api } from './App';

const RELEASES = [
  {
    version: 'v1.0',
    date: '6 April 2026',
    iso: '2026-04-06',
    items: [
      {
        title: 'SQETrack is live',
        detail: 'Track your confidence across 259 FLK1 and FLK2 topics, import BARBRI practice results, practise with 220 official SRA questions, plan your revision week by week, and track your progress toward exam day.',
      },
    ],
  },
];

export default function Changelog({ onViewed }) {
  useEffect(() => {
    // Mark changelog as viewed
    api('/api/settings', {
      method: 'POST',
      body: JSON.stringify({ changelog_last_viewed: new Date().toISOString().slice(0, 10) }),
    });
    if (onViewed) onViewed();
  }, []); // eslint-disable-line

  const release = RELEASES[0];

  return (
    <div className="changelog-page">
      <div className="changelog-header">
        <div className="changelog-title">What's new</div>
        <div className="changelog-subtitle">SQETrack release notes.</div>
      </div>
      <div className="changelog-list">
        <div className="changelog-release changelog-release--open">
          <div className="changelog-release-header-static">
            <div className="changelog-release-left">
              <span className="changelog-version">{release.version}</span>
              <span className="changelog-date">{release.date}</span>
            </div>
          </div>
          <div className="changelog-items">
            {release.items.map((item, i) => (
              <div key={i} className="changelog-item">
                <div className="changelog-item-title">{item.title}</div>
                <div className="changelog-item-detail">{item.detail}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

// Export for use in App.js to determine whether to show "New" badge
export const LATEST_CHANGELOG_DATE = RELEASES[0].iso;
